module.exports = __webpack_public_path__ + "static/media/picante-audaz.b1c4c36e.png";